import { render, staticRenderFns } from "./VolumeGraph.vue?vue&type=template&id=15c2b42c"
import script from "./VolumeGraph.vue?vue&type=script&lang=js"
export * from "./VolumeGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports